/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Token_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Could not copy to clipboard." |
*
* @param {Agents_Token_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_token_copy_failed = /** @type {((inputs?: Agents_Token_Copy_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Token_Copy_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren in die Zwischenablage fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Could not copy to clipboard.")
});